import { render, staticRenderFns } from "./NoticeItem.vue?vue&type=template&id=49330d00"
import script from "./NoticeItem.vue?vue&type=script&lang=js"
export * from "./NoticeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports